export const ACCESS_DENIED_EVENT = "intelligenic:access-denied";
export const POLICY_EPOCH_EVENT = "intelligenic:policy-epoch";

export interface PolicyEpochEventDetail {
    policyEpoch: string;
}

export function notifyAccessDenied(): void {
    if (typeof window !== "undefined") window.dispatchEvent(new Event(ACCESS_DENIED_EVENT));
}

export function notifyPolicyEpoch(policyEpoch: string): void {
    if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent<PolicyEpochEventDetail>(POLICY_EPOCH_EVENT, { detail: { policyEpoch } }));
    }
}
